var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',{staticClass:"d-inline-flex align-items-center btn-price-list",on:{"click":_vm.onclick}},[_vm._v("\n  "+_vm._s(_vm.$t('pages.checkins_detail.label_price_list'))+"\n  "),_c('Icon',{staticClass:"rounded-icon ml-3",attrs:{"name":"arrowNarrowUpRight","width":"27"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }